module.exports = __webpack_public_path__ + "media/packs/compcalc/components/images/matrix-fada54222c58af56371ad5a074297b5b.png";